import * as React from 'react'
import { MigrationResult } from '../../../api'
import { Typography, Box, List, ListItemText, ListItem } from 'cs-kevlar-react'

interface MigrationSummaryProps {
  className?: string
  result: MigrationResult
}

export const MigrationSummary: React.FunctionComponent<MigrationSummaryProps> = ({
  result,
}) => {
  return (
    <Box>
      <Typography>Total User Licenses</Typography>
      <ul>
        <li>
          <Typography>Before: {result.removedAgencyLicenseCount}</Typography>
        </li>
        <li>
          <Typography>After: {result.createdAgencyLicenseCount}</Typography>
        </li>
      </ul>
    </Box>
  )
}
